var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto"}},[_c('video',{ref:"videoPlayer",staticClass:"video",attrs:{"data-dashjs-player":"","src":_vm.info.url,"controls":"true","autoplay":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }